import PatientShowContent from "./PatientShowContent";
export default PatientShowContent;
